import { FC } from 'react';
import type { SecondaryMarketProductInternalUser } from 'state/secondaryMarket/productSearch';

import { ListItem } from './ListItem';

type Props = {
  data: SecondaryMarketProductInternalUser;
};

export const ListItems: FC<Props> = ({ data: { name, issuedQty, salesMessage, tradeMessage } }) => (
  <ul className="list-group list-group-flush border-top border-secondary mt-3">
    {salesMessage !== undefined && <ListItem label="secondaryMarket.modal.salesMessage" value={salesMessage} />}
    {tradeMessage !== undefined && <ListItem label="secondaryMarket.modal.tradeMessage" value={tradeMessage} />}
    {name !== undefined && <ListItem label="secondaryMarket.modal.product" value={name} />}
    {issuedQty !== undefined && <ListItem label="secondaryMarket.modal.issuedQty" value={issuedQty?.toFixed()} />}
  </ul>
);
